import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useSelector } from 'react-redux';
import CLabel from '../../../Common/CLabel';
import { useGetContractsPropsMaintainer, useGetPropsMaintainer } from '../../../../hooks/services/sBook/useOfContract';
import moment from 'moment';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import i18next from 'i18next';

const SidePanelContractInformation = (props) => {
    const { t } = useTranslation();

    

    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
    const { _contractPropListValues: listContractsPropValues } = useSelector((state) => state.maintainerScope);

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_Contract = props.inputParam_Contract;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    useGetContractsPropsMaintainer(listContractsProps);
    useGetPropsMaintainer(listContractsPropValues);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div> 
    };

    const getCustomProp = (listPropValues, column) => {
        let object = null;
        
        if (column.valType === "str") {
            object = { text: column.name, value: inputParam_Contract.l_props.find(x => x.contractPropId === column.id).strVal };
        }
        else if (column.valType === "num") {
            object = { text: column.name, value: inputParam_Contract.l_props.find(x => x.contractPropId === column.id).numVal };
        }
        else if (column.valType === "list") {
            const contractPropItem = inputParam_Contract.l_props.find(x => x.contractPropId === column.id);
            const aux_contractPropListItem = listPropValues.filter(x => x.contractPropId === column.id);
            const contractPropValueItem = contractPropItem ? aux_contractPropListItem.find(y => y.id === contractPropItem.cplId) : null;

            object = { text: column.name, value: contractPropValueItem ? contractPropValueItem.text : null };
        }
        else {
            object = { text: column.name, value: inputParam_Contract.l_props.find(x => x.contractPropId === column.id).strVal };
        }
    
        return <CLabel labelText={object.text} labelValue={object.value} />;
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-contractinformation') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <>
                {
                    (inputParam_Contract) &&
                    <>                          
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-code')} labelValue={inputParam_Contract.contractCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-name')} labelValue={inputParam_Contract.name} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">

                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitybuyername')} labelValue={inputParam_Contract.legalEntityBuyerName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitysuppliername')} labelValue={inputParam_Contract.legalEntitySupplierName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={inputParam_Contract.businessUnitName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-segmentname')} labelValue={inputParam_Contract.segmentName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-category')} labelValue={inputParam_Contract.categoryName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-currencyname')} labelValue={inputParam_Contract.currencyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-adminuser')} labelValue={inputParam_Contract.adminUsername} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-startdate')} labelValue={moment(inputParam_Contract.startDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-enddate')} labelValue={moment(inputParam_Contract.endDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-amount')} labelValue={inputParam_Contract.amount && parseFloat(inputParam_Contract.amount.toFixed(2)).toLocaleString(i18next.language)} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-endowment')} labelValue={inputParam_Contract.endowment} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-scope')} labelValue={inputParam_Contract.scope} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-contractstatus')} labelValue={inputParam_Contract.statusName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-itemstatus')} labelValue={!isNullUndefinedOrEmpty(inputParam_Contract.estado_partida_abierta)? (inputParam_Contract.estado_partida_abierta === true ? t('data-lang-lbl-openparties') : t('data-lang-lbl-closedparties')) : t('data-lang-lbl-nodata') } linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        {
                            inputParam_Contract && inputParam_Contract.l_props && listContractsPropValues && listContractsProps && listContractsProps.filter(x => x.deactivate === false).map(obj => 
                                <Row className="pt-3">
                                    <Col xl={12}>
                                        {getCustomProp(listContractsPropValues, obj)}
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelContractInformation;